import CustomSnackbar from './Snackbar'

export default CustomSnackbar
